export default __webpack_public_path__ + "static/media/simple-Line-Icons.020f280b.svg";